import {
    MedicalActTemplate,
    CreateMedicalActTemplateDto,
    UpdateMedicalActTemplateDto,
} from '@/core/models/medical-act.model'

import { cacher, cacheByIdArg } from '@/utils/rtkQueryCacheUtils'
import { baseApi, Tag } from './base'

type GetTemplatesParams = {
    global?: boolean
    all?: boolean
}

export const medicalActTemplateApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Get all templates visible to the user's establishment (global + establishment-specific)
         */
        getMedicalActTemplates: builder.query<MedicalActTemplate[], GetTemplatesParams | void>({
            query: (params) => ({
                url: '/medical-act-templates',
                method: 'GET',
                params: params || {},
            }),
            providesTags: cacher.providesList(Tag.MEDICAL_ACT_TEMPLATE),
        }),

        /**
         * Get a single template by ID
         */
        getMedicalActTemplate: builder.query<MedicalActTemplate, string>({
            query: (id) => `/medical-act-templates/${id}`,
            providesTags: cacheByIdArg(Tag.MEDICAL_ACT_TEMPLATE),
        }),

        /**
         * Create a new template
         */
        createMedicalActTemplate: builder.mutation<MedicalActTemplate, CreateMedicalActTemplateDto>({
            query: (body) => ({
                url: '/medical-act-templates',
                method: 'POST',
                body,
            }),
            invalidatesTags: cacher.invalidatesList(Tag.MEDICAL_ACT_TEMPLATE),
        }),

        /**
         * Update a template
         */
        updateMedicalActTemplate: builder.mutation<MedicalActTemplate, { id: string; changes: UpdateMedicalActTemplateDto }>({
            query: ({ id, changes }) => ({
                url: `/medical-act-templates/${id}`,
                method: 'PUT',
                body: changes,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: Tag.MEDICAL_ACT_TEMPLATE, id },
                { type: Tag.MEDICAL_ACT_TEMPLATE, id: 'LIST' },
            ],
        }),

        /**
         * Delete a template (soft delete)
         */
        deleteMedicalActTemplate: builder.mutation<MedicalActTemplate, string>({
            query: (id) => ({
                url: `/medical-act-templates/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: cacher.invalidatesList(Tag.MEDICAL_ACT_TEMPLATE),
        }),
    }),
    overrideExisting: false,
})
